<cx-carousel
  [items]="items$ | async"
  [title]="title$ | async"
  [template]="carouselItem"
  class="product-carousel__carousel"
  [itemWidth]="getItemWidth()"
  >
</cx-carousel>

<ng-template #carouselItem let-item="item">
  <a
    tabindex="0"
    [routerLink]="{ cxRoute: 'product', params: item } | cxUrl"
    class="product-carousel__carousel-item-anchor"
    >
    @if (showUspInfo === 'true') {
      <h4
        class="product-carousel__carousel-item-uspinfo"
        [ngClass]="{ red: showUspInfoInRed === 'true' }"
        >
        {{ item.uspInfo }}
      </h4>
    }
    <cx-media [container]="item.images?.PRIMARY" format="product"></cx-media>
    <h4 class="product-carousel__carousel-item-title">{{ item.name }}</h4>
    @if (showSummary === 'true') {
      <p
        class="product-carousel__carousel-item-summary"
        >
        {{ item.summary }}
      </p>
    }
    <div
      class="product-carousel__carousel-item-price price"
      [ngClass]="{ red: showPriceInRed === 'true' }"
      >
      {{ item.ekPrice?.formattedValue }}
    </div>
  </a>
</ng-template>
